import { GET_LOGGED_EMPLOYEE, CHANGE_PROFILE_MODAL_STATE, IS_LOADING } from "./loggedEmployeeConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { downloadFile } from "../../utils";

export function getLoggedEmployeeAction(loggedEmployee) {
    return {
        type: GET_LOGGED_EMPLOYEE,
        loggedEmployee: loggedEmployee,
    };
}

export function changeProfileModalStateAction(profileModalOpened) {
    return {
        type: CHANGE_PROFILE_MODAL_STATE,
        profileModalOpened: profileModalOpened,
    };
}

export function loggedEmployeeIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "Employé connecté",
        isLoading: value,
    };
}

export function changeProfileModalState(profileModalOpened) {
    return (dispatch) => {
        dispatch(changeProfileModalStateAction(profileModalOpened));
    };
}

export async function getLoggedEmployee(userId, empId) {
    return new Promise((resolve, reject) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/employees/get_logged_employee/" + userId + "/" + empId, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((loggedEmployee) => {
                return resolve(loggedEmployee);
            })
            .catch((err) => {
                console.error("Erreur : loggedEmployeeActions - getLoggedEmployee", err);
                return reject(err);
            });
    });
}

export function loadLoggedEmployee(userId, empId, onSuccess, discreet) {
    return (dispatch) => {
        getLoggedEmployee(userId, empId)
            .then((loggedEmployee) => {
                dispatch(getLoggedEmployeeAction(loggedEmployee));

                if (onSuccess && typeof onSuccess === "function") onSuccess(loggedEmployee);
            })
            .catch((err) => {
                console.error("Erreur lors de la récupération de l'employé connecté !", err);

                if (!discreet)
                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la récupération de l'employé connecté !",
                        })
                    );
            });
    };
}

export function downloadHabilitationCard(user) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        dispatch(loggedEmployeeIsLoading(true));
        fetchWithTimeout("/api/v1/employees/getHabilitationCard/" + user.id + "/" + user.emp_id, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((habilitationCard) => {
                if (!habilitationCard) {
                    dispatch(
                        throwErrorMessage({
                            title: "Une erreur s'est produite lors de la récupération de la carte d'habilitation",
                        })
                    );
                    dispatch(loggedEmployeeIsLoading(false));
                    return;
                }

                var dataURI = "data:application/pdf;base64," + habilitationCard;
                downloadFile(dataURI, "CarteHabilitation");
                dispatch(loggedEmployeeIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : loggedEmployeeActions - downloadHabilitationCard", err);
                dispatch(
                    throwErrorMessage({
                        title: "Une erreur s'est produite lors de la récupération de la carte d'habilitation",
                    })
                );
                dispatch(loggedEmployeeIsLoading(false));
            });
    };
}
